<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page="10"
          class="elevation-1 mb-3"
          item-key="id"
          :single-expand="true"
          show-expand
          :expanded.sync="expanded"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>
              {{ item.id }}
            </v-btn>
          </template>

          <template v-slot:item.category="{ item }">
            {{ item.category }}
            <span class="caption grey--text">({{ item.value_unitary }})</span>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              small
              class="white--text"
              :color="handleColorStatus(item.status)"
              >{{ item.statusUi }}</v-chip
            >
          </template>

          <!-- Buttons OPEN and CLOSE TD -->
          <template
            v-slot:item.data-table-expand="{ item, isExpanded, expand }"
          >
            <v-btn
              @click="[expand(true), getInvoice(item.id)]"
              v-if="!isExpanded"
              class="info"
              light
              small
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              @click="[expand(false), (invoice = '')]"
              v-if="isExpanded"
              class="white"
              light
              small
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- // Buttons OPEN and CLOSE TD -->

          <!-- ############### -->
          <!-- INVOICE DETAILS -->
          <!-- ############### -->
          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length" class="pa-4">
              <div v-if="!invoice" class="text-center pa-10">
                <v-progress-circular indeterminate></v-progress-circular>
              </div>
              <div v-else>
                <v-card>
                  <v-toolbar dense elevation="0">
                    <v-toolbar-title class="text-h5"
                      >Fatura Nº {{ invoice.id }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      class="info"
                      @click="
                        [
                          $router.push({
                            path: `invoices/invoice/${invoice.id}`,
                          }),
                          showDialog(),
                        ]
                      "
                      >{{ $t("openInvoice") }}</v-btn
                    >
                  </v-toolbar>
                  <div class="pa-4">
                    <div class="overline pb-2 d-flex">
                      <div>{{ $t("payment") }}</div>
                      <v-spacer></v-spacer>
                      <div>{{ $t("TOTAL") }} {{ invoice.value_invoice }}</div>
                    </div>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">{{ $t("code") }}</th>
                            <th class="text-right">{{ $t("value") }}</th>
                            <th class="text-right">{{ $t("dueDate") }}</th>
                            <th class="text-right">{{ $t("interest") }}</th>
                            <th class="text-right">{{ $t("status") }}</th>
                            <th class="text-right">{{ $t("pay") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in charges" :key="item.id">
                            <td class="py-2">{{ item.id }}</td>
                            <td class="py-2 text-right">
                              {{ item.value_charge }}
                            </td>
                            <td
                              class="py-2 text-right"
                              :class="
                                item.date_current > item.due_date &&
                                item.status == '1'
                                  ? 'red--text'
                                  : ''
                              "
                            >
                              {{ item.due_date | formatDate }}
                            </td>
                            <td class="text-right">{{ item.vat }}</td>
                            <td class="py-2 text-right">
                              <v-chip
                                small
                                :color="handleColorStatus(item.status)"
                                class="white--text"
                                >{{ item.statusUi }}</v-chip
                              >
                            </td>
                            <td class="py-2 text-right">
                              <!-- ============================ -->
                              <!-- Condicional de PIX ou BOLETO -->
                              <!-- ============================ -->
                              <template
                                v-if="
                                  !(
                                    item.date_pix == '0000-00-00 00:00:00' ||
                                    item.date_pix == null
                                  )
                                "
                              >
                                <template
                                  v-if="
                                    item.status == '1' &&
                                      item.date_current <= item.due_date &&
                                      item.date_current <= item.date_pix
                                  "
                                >
                                  <!-- BOTÃO PIX -->
                                  <v-btn
                                    color="white"
                                    class="ma-1 mr-0"
                                    light
                                    small
                                    @click="showDialogPix(item)"
                                    target="_black"
                                    ><v-icon small left>mdi-qrcode</v-icon
                                    >Pix</v-btn
                                  >
                                  <!-- COPIAR CODE -->
                                  <v-btn
                                    v-if="item.barcode != ''"
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    @click="$copy(item.barcode)"
                                    ><v-icon left size="14"
                                      >mdi-content-copy</v-icon
                                    >{{ $t("code") }}</v-btn
                                  >
                                </template>

                                <!-- BOTÃO PIX SEGUNDA VIA -->
                                <template
                                  v-if="
                                    (item.date_current > item.date_pix ||
                                      item.date_current > item.due_date) &&
                                      item.status == '1'
                                  "
                                >
                                  <v-btn
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    :disabled="disabled"
                                    @click="newBillet(item.id, 'newBilletPix')"
                                    ><v-icon left size="14"
                                      >mdi-numeric-2-box-multiple-outline</v-icon
                                    >{{ $t("seccondCopy") }}</v-btn
                                  >
                                </template>
                              </template>
                              <template v-else>
                                <template
                                  v-if="
                                    item.status == '1' &&
                                      item.date_current <= item.due_date
                                  "
                                >
                                  <!-- BOTÃO BOLETO -->
                                  <v-btn
                                    color="white"
                                    class="ma-1 mr-0"
                                    light
                                    small
                                    :href="item.link_billet"
                                    target="_black"
                                  >
                                    <v-icon left>mdi-barcode</v-icon>
                                    {{ $t("ticket") }}
                                  </v-btn>
                                  <!-- COPIAR CODE -->
                                  <v-btn
                                    v-if="item.barcode != ''"
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    @click="$copy(item.barcode)"
                                    ><v-icon left size="14"
                                      >mdi-content-copy</v-icon
                                    >{{ $t("code") }}</v-btn
                                  >
                                </template>
                                <!-- BOTÃO BOLETO SEGUNDA VIA -->
                                <template
                                  v-if="
                                    item.date_current > item.due_date &&
                                      item.status == '1'
                                  "
                                >
                                  <v-btn
                                    small
                                    color="white"
                                    light
                                    class="ma-1 mr-0"
                                    :disabled="disabled"
                                    @click="newBillet(item.id, 'newBilletPix')"
                                    ><v-icon left size="14"
                                      >mdi-numeric-2-box-multiple-outline</v-icon
                                    >{{ $t("seccondCopy") }}</v-btn
                                  >
                                </template>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card>
              </div>
            </td>
          </template>
          <!-- / INVOICE DETAILS -->
        </v-data-table>
        <DialogDepositPix />
      </v-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
import DialogDepositPix from "@/components/common/financial/dialogDepositPix";
export default {
  name: "views-backoffice-administrator-account-invoices",
  components: {
    DialogDepositPix,
    HeaderPrint,
  },
  data: () => ({
    expanded: [],
    search: null,
    disabled: false,
    items: [],
    dateExpiration: "",
    invoice: "",
    charges: "",
  }),
  async mounted() {
    this.listInvoices();
    // console.log("pix", this.depositPix.status);
  },
  computed: {
    headers() {
      return [
        { text: "Nº", value: "id" },
        { text: this.$t("period"), value: "date_range_invoice" },
        { text: this.$t("plan"), value: "category" },
        // { text: "Valor Unitário", value: "value_unitary" },
        { text: this.$t("amountTotal"), value: "value_invoice" },
        { text: this.$t("status"), value: "status" },
        // { text: "Ações", value: "actions" },
        { text: this.$t("actions"), value: "data-table-expand" },
      ];
    },
    depositPix() {
      return this.$store.state.depositPix;
    },
  },
  methods: {
    // Get List Invoices
    async listInvoices() {
      const response = await this.$request.get(
        "administrator/account/invoices"
      );
      if (response.length == 0) return;
      var data = response.dados;
      // Handle data (important!):
      this.items = await Promise.all(
        this.handleDate(data),
        this.handleStatus(data)
      );
      // console.log(this.items);
    },

    // Handle 'date' (tratamento da data)
    handleDate(data) {
      return data.map(async (item) => {
        // Handle UI Range:
        var dateStart = new Date(
          item.date_start.replace(" ", "T")
        ).toLocaleDateString();
        var dateEnd = new Date(
          item.date_end.replace(" ", "T")
        ).toLocaleDateString();
        var date_range_invoice = `${dateStart} - ${dateEnd}`;

        // Handle Date Expiration (Para mostrar o botão de 2ª via)
        // É necessário incrementear 8 dias na data de registro
        // para comparar com a data atual.
        // Se a data atual for maior que a data de expiração
        // mostrar o botão de segunda via, caso ele ainda
        // estiver com o status pendente ou 1.
        var date_expiration = new Date(item.date_register);
        date_expiration.setDate(date_expiration.getDate() + 8);
        date_expiration = new Date(date_expiration).toLocaleString();

        Object.assign(item, { date_range_invoice, date_expiration });

        return item;
      });
    },

    // Handle 'string' para alguns dados serem encontrados na busca.
    handleStatus(data) {
      return data.map((item) => {
        if (item.status == "1") {
          item.statusUi = this.$t("pending");
        } else if (item.status == "2") {
          item.statusUi = this.$t("paidLabel");
        } else {
          item.statusUi = this.$t("disabled");
        }
        return item;
      });
    },

    // Handle color v-chip status
    handleColorStatus(status) {
      const colorStatus = {
        5: "grey",
        2: "success",
        1: "orange",
      };
      return colorStatus[status];
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },

    // Segunda Via
    async newBillet(id_charge, endpoint) {
      this.disabled = true;
      const response = await this.$request.post(
        `administrator/account/${endpoint}`,
        {
          id_charge: id_charge,
        }
      );
      if (response.length == 0) {
        this.disabled = false;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("errorGeneratingDuplicate"),
          color: "error",
        });
        return;
      }
      this.disabled = false;
      await this.getInvoice(this.invoice.id);
      // const link = response.dados;
      // this.showDialogPix(link);
      // window.open(link, "_blank").focus;
    },

    // Open Invoice Details "Open TD"
    async getInvoice(id_invoice) {
      // Reset data
      this.invoice = "";
      this.charges = "";

      var response = await this.$request.post(
        "administrator/account/getInvoice",
        {
          id_invoice: id_invoice,
        }
      );

      if (response.length == 0) return;
      // Invoice Details:
      this.invoice = response.dados;
      // Handle charges:
      this.charges = this.handleStatus(response.charges);
    },
    showDialogPix(charge) {
      // console.log(charge);
      this.$store.commit("dialogDepositPix", {
        status: true,
        value: charge.value_charge,
        imgQrcode: charge.link_billet,
        codeQr: charge.barcode,
      });
    },
  },
  filters: {
    formatDate: function(date) {
      return new Date(date).toLocaleDateString();
    },
    // decimalAdjustment: function (num) {
    //   return -(Math.round(-num + "e+2") + "e-2");
    // },
  },
};
</script>
<style scoped>
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
  min-height: 32px !important;
}
</style>
